<div
  class="dropdown-menu with-pinned-item"
  DMClickOutside
  (clickOutside)="clearContainer()"
  [ngClass]="wrapperClass"
  [style.top]="(position | async)?.y + 'px'"
  [style.left]="(position | async)?.x + 'px'"
  [style.width]="(width | async) + 'px'"
  [style.display]="'block'"
>
  <ul class="dropdown-menu-list">
    <li
      class="dropdown-menu-item"
      [ngClass]="{ clickable: getClickable() }"
      *ngFor="let option of options; trackBy: trackByValue"
      (click)="clickDropdownMenu(option)"
    >
      <span class="simple-list-item" [ngClass]="{ clickable: getClickable() }">
        {{ option.title || option.name }}
      </span>
    </li>
  </ul>
</div>
